type FieldIssue = {
  readonly path: readonly PropertyKey[];
  readonly message: string;
};

/** Thrown by writes whose data fails its schema; forms map `issues` onto their fields. */
export class ValidationError extends Error {
  constructor(
    message: string,
    readonly issues: readonly FieldIssue[],
  ) {
    super(message);
  }
}
